var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "formInput__wrapper" }, [
    _c(
      "label",
      { staticClass: "formRadio", attrs: { for: _vm.fieldId } },
      [
        _c("input", {
          ref: _vm.fieldId,
          staticClass: "formRadio__input",
          class: _vm.fieldClasses,
          attrs: {
            id: _vm.fieldId,
            type: "radio",
            name: _vm.fieldName,
            required: _vm.fieldRequired,
            disabled: _vm.fieldDisabled,
            "aria-checked": _vm.fieldChecked ? _vm.fieldChecked : "false",
            "aria-invalid": `${_vm.ariaInvalidStatus}`,
            "data-gtm": _vm.dataGtm,
          },
          domProps: { value: _vm.fieldValue, checked: _vm.fieldChecked },
          on: { change: _vm.handleChange },
        }),
        _vm._v(" "),
        _vm.fieldLabel
          ? _c(
              "span",
              { staticClass: "formRadio__labelText", class: _vm.labelClasses },
              [_vm._v("\n            " + _vm._s(_vm.fieldLabel) + "\n        ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default"),
        _vm._v(" "),
        _vm.fieldRequired === true
          ? _c("span", { staticClass: "formRadio__required" }, [
              _c("span", { staticClass: "visually-hidden" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.trans("LABEL_TEXT_SR_REQUIRED")) +
                    "\n            "
                ),
              ]),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }